import { useEffect, useState } from 'react';
import './App.css';
import axios from 'axios';
import { BrowserRouter, Route, Routes, useParams } from 'react-router-dom';
import { message } from 'antd';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'antd/dist/reset.css';
function App() {








  return (
    <div className="App">
      {/* Page No 1 */}





      <div>
        <BrowserRouter>


          <Routes>
            <Route path="/:id" element={<Report />} />
          </Routes>
        </BrowserRouter>
      </div>







    </div>
  );
}




const Report = () => {

  const { id } = useParams();
  const [kit, setkit] = useState([])
  const [totaldistoshow, settotaldistoshow] = useState([])
  const [doadinggg, setdoadinggg] = useState(false)

  const getdata = async () => {


    let data = JSON.stringify({
      "_id": id
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    await axios.request(config)
      .then(async (response) => {


        // Filter out unwanted results
        const filteredResults = await response.data.result.filter(item =>
          ![
            "GD1", "Cor a 12_RUO", "Mes a 1_RUO",
            "Pis v 4_RUO", "Pru p 7_RUO", "GD2", "tIgE", "Ole e 7_RUO",
            "GD3", "GD4"
          ].includes(item.name)
        );

        // Update state with filtered results
        await setkit({ ...response.data, result: filteredResults });
        await settotaldistoshow(filteredResults.filter(item => item.value >= 1));

        // console.log()
        // await setkit(response.data)
        // await settotaldistoshow(response.data.result.filter((item) => item.value >= 3))





      })
      .catch((error) => {
        console.log(error);
      });


  }



  useEffect(() => {


    getdata()


  }, [])

  useEffect(() => {

    if (kit.length > 0) {
      download();
    }
  }, [kit])




  const clinicalRelevanceData = [
    {
      "commonName": "Bahia grass",
      "name": "Pas n",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Paspalum notatum",
      "tissue": "Pollen",
      "discription": "The positive test for bahia grass, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Bermuda grass",
      "name": "Cyn d",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Cynodon dactylon",
      "tissue": "Pollen",
      "discription": "The positive test for bermuda grass, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Bermuda grass",
      "name": "Cyn d 1",
      "type": "M",
      "moleculeName": "Grasses, Group 1; CCD-bearing Protein (XF); Expansin",
      "latinName": "Cynodon dactylon",
      "tissue": "Pollen",
      "discription": "Marker of reactivity to carbohydrates of plant and insects glycoproteins. When positive is associated with the positivity of glycoprotein allergens. It has great relevance in the interpretation of diagnostic tests, but has virtually no clinically impact, unless an IgE reactivity to the protein is associated. A positive result for this marker can generate positive results to allergen extracts derived from plants and insects."
    },
    {
      "commonName": "Common reed",
      "name": "Phr a",
      "type": "E",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "The positive test for the common reed, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Perennial ryegrass",
      "name": "Lol p 1",
      "type": "M",
      "moleculeName": "Grasses, Group 1; CCD-bearing Protein (XF); Expansin",
      "latinName": "Lolium perenne",
      "tissue": "Pollen",
      "discription": "Marker of reactivity to carbohydrates of plant and insects glycoproteins. When positive is associated with the positivity of glycoprotein allergens. It has great relevance in the interpretation of diagnostic tests, but has virtually no clinically impact, unless an IgE reactivity to the protein is associated. A positive result for this marker can generate positive results to allergen extracts derived from plants and insects."
    },
    {
      "commonName": "Rye ",
      "name": "Sec c_pollen",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Secale cereale",
      "tissue": "Pollen",
      "discription": "The positive test for rye pollen, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Timothy",
      "name": "Phl p 1",
      "type": "M",
      "moleculeName": "Grasses, Group 1; CCD-bearing Protein (XF); Expansin",
      "latinName": "Phleum pratense",
      "tissue": "Pollen",
      "discription": "Marker of reactivity to carbohydrates of plant and insects glycoproteins. When positive is associated with the positivity of glycoprotein allergens. It has great relevance in the interpretation of diagnostic tests, but has virtually no clinically impact, unless an IgE reactivity to the protein is associated. A positive result for this marker can generate positive results to allergen extracts derived from plants and insects."
    },
    {
      "commonName": "Timothy",
      "name": "Phl p 2",
      "type": "M",
      "moleculeName": "Grasses, Group 2",
      "latinName": "Phleum pratense",
      "tissue": "Pollen",
      "discription": "Specific allergen markers of allergy to grass pollen; Inhalation can cause symptoms such as rhinitis, conjunctivitis, asthma in the springtime. Symptoms may be more severe if allergic to other specific markers of the same pollen."
    },
    {
      "commonName": "Timothy",
      "name": "Phl p 5.0101",
      "type": "M",
      "moleculeName": "Grasses, Group 5",
      "latinName": "Phleum pratense",
      "tissue": "Pollen",
      "discription": "Specific allergen markers of allergy to grass pollen; Inhalation can cause symptoms such as rhinitis, conjunctivitis, asthma in the springtime. Symptoms may be more severe if allergic to other specific markers of the same pollen."
    },
    {
      "commonName": "Timothy",
      "name": "Phl p 6",
      "type": "M",
      "moleculeName": "Grasses, Group 6",
      "latinName": "Phleum pratense",
      "tissue": "Pollen",
      "discription": "Specific allergen markers of allergy to grass pollen; Inhalation can cause symptoms such as rhinitis, conjunctivitis, asthma in the springtime. Symptoms may be more severe if allergic to other specific markers of the same pollen."
    },
    {
      "commonName": "Timothy",
      "name": "Phl p 7",
      "type": "M",
      "moleculeName": "Polcalcin",
      "latinName": "Phleum pratense",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in pollen of many plant species; It can cause symptoms by inhalation (rhinitis), but it is frequently associated with asthma; symptomsmay be present for the entire period of the presence of any pollen. It is not present in plant foods."
    },
    {
      "commonName": "Timothy",
      "name": "Phl p 12",
      "type": "M",
      "moleculeName": "Profilin",
      "latinName": "Phleum pratense",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Acacia",
      "name": "Aca m",
      "type": "E",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "Its pollen primarily causes seasonal respiratory allergies, while occupational exposure may lead to contact dermatitis. Cross-reactivity with other legumes and pollen-associated foods is possible but less documented than with major allergenic trees like birch.*"
    },
    {
      "commonName": "Alder",
      "name": "Aln g 1",
      "type": "M",
      "moleculeName": "Fagales, Group 1; Bet v 1-like",
      "latinName": "Alnus glutinosa",
      "tissue": "Pollen",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Alder",
      "name": "Aln g 4",
      "type": "M",
      "moleculeName": "Polcalcin",
      "latinName": "Alnus glutinosa",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in pollen of many plant species; It can cause symptoms by inhalation (rhinitis), but it is frequently associated with asthma; symptomsmay be present for the entire period of the presence of any pollen. It is not present in plant foods."
    },
    {
      "commonName": "Arizona cypress",
      "name": "Cup a 1",
      "type": "M",
      "moleculeName": "Cupressaceae, Group 1; CCD-bearing Protein (XF); Pectate Lyase",
      "latinName": "Cupressus arizonica",
      "tissue": "Pollen",
      "discription": "Specific allergen markers of allergy to pollen of Cupressaceae; Inhalation can cause symptoms such as rhinitis, conjunctivitis, rarely asthma, in the winter and early springtime. Some species have their pollinating time in fall."
    },
    {
      "commonName": "Ash",
      "name": "Fra e",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Fraxinus excelsior",
      "tissue": "Pollen",
      "discription": "The positive test for the ash, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Ash",
      "name": "Fra e 1",
      "type": "M",
      "moleculeName": "Oleaceae, Group 1; Ole e 1-like",
      "latinName": "Fraxinus excelsior",
      "tissue": "Pollen",
      "discription": "Allergen marker of allergy to olive pollen , present in other Oleaceae (ash, privet); it is present only in pollen and can cause symptoms such as rhinitis and asthma by inhalation, often severe depending on the level of exposure."
    },
    {
      "commonName": "Beech",
      "name": "Fag s 1",
      "type": "M",
      "moleculeName": "Fagales, Group 1; Bet v 1-like",
      "latinName": "Fagus sylvatica",
      "tissue": "Pollen",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Cottonwood",
      "name": "Pop n",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Populus deltoides",
      "tissue": "Pollen",
      "discription": "This is a moderate aeroallergen with clinical significance in early spring, particularly in Europe. Its pollen shares strong cross-reactivity with birch, leading to overlapping respiratory and food allergy syndromes. While less potent than birch, it contributes to the \"spring pollen peak\" and may exacerbate symptoms in polysensitized individuals.*"
    },
    {
      "commonName": "Cypress",
      "name": "Cup s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Cupressus sempervirens",
      "tissue": "Pollen",
      "discription": "The positive test for the cypress, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Date palm",
      "name": "Pho d 2",
      "type": "M",
      "moleculeName": "Profilin",
      "latinName": "Phoenix dactylifera",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Elm",
      "name": "Ulm c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ulmus campestris",
      "tissue": "Pollen",
      "discription": "A clinically relevant aeroallergen in regions where elms are prevalent, primarily causing seasonal respiratory allergies. Cross-reactivity with other tree pollens and plant foods may broaden its clinical impact.*"
    },
    {
      "commonName": "Hazel",
      "name": "Cor a_pollen",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Corylus avellana",
      "tissue": "Pollen",
      "discription": "The positive test for hazel pollen, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Hazel",
      "name": "Cor a 1.0103",
      "type": "M",
      "moleculeName": "Fagales, Group 1; Bet v 1-like",
      "latinName": "Corylus avellana",
      "tissue": "Pollen",
      "discription": "This is a pollen-specific allergen from Corylus avellana with clinical significance in respiratory allergies (often comorbid with birch) and pollen-food syndrome (oral allergy to hazelnut/related foods).*"
    },
    {
      "commonName": "London plane tree",
      "name": "Pla a 1",
      "type": "M",
      "moleculeName": "Invertase Inhibitor",
      "latinName": "Platanus acerifolia",
      "tissue": "Pollen",
      "discription": "Specific allergen marker of allergy to plane tree pollen; Springtime exposure by inhalation may cause rhinitis and conjunctivitis, rarely asthma."
    },
    {
      "commonName": "London plane tree",
      "name": "Pla a 2",
      "type": "M",
      "moleculeName": "CCD-bearing Protein (XF); Polygalacturonase",
      "latinName": "Platanus acerifolia",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in pollen of many plant species; It can cause symptoms by inhalation (rhinitis); symptoms may be present for the entire period of the presence of any pollen."
    },
    {
      "commonName": "London plane tree",
      "name": "Pla a 3",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Platanus acerifolia",
      "tissue": "Pollen",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Mountain cedar",
      "name": "Jun a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Juniperus ashei",
      "tissue": "Pollen",
      "discription": "This is a major seasonal allergen in the southern U.S., causing \"Cedar fever\" (severe winter hay fever), and asthma exacerbations in sensitized individuals. There may be cross-reactivity with global Cupressaceae species (e.g., Japanese cedar, Mediterranean cypress).*"
    },
    {
      "commonName": "Mulberry tree",
      "name": "Mor r",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Morus rubra",
      "tissue": "Pollen",
      "discription": "The positive test for red mulberry pollen, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Olive",
      "name": "Ole e 1",
      "type": "M",
      "moleculeName": "Oleaceae, Group 1; CCD-bearing Protein (XF); Ole e 1-like",
      "latinName": "Olea europaea",
      "tissue": "Pollen",
      "discription": "Marker of reactivity to carbohydrates of plant and insects glycoproteins. When positiveis associated with the positivity of glycoprotein allergens. It has great relevance in the interpretation of diagnostic tests, but has virtually no clinically impact, unless an IgE reactivity to the protein is associated. A positive result for this marker can generate positive results to allergen extracts derived from plants and insects."
    },
    {
      "commonName": "Olive",
      "name": "Ole e 9",
      "type": "M",
      "moleculeName": "Glucanase",
      "latinName": "Olea europaea",
      "tissue": "Pollen",
      "discription": "Group of allergens present in many plant species, both in pollen edible parts; it can may cause respiratory symptoms by inhalation such as rhinitis and asthma, even of a certain severity."
    },
    {
      "commonName": "Paper mulberry",
      "name": "Bro pa",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Broussonetia papyrifera",
      "tissue": "Pollen",
      "discription": "The positive test for the paper mulberry, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Silver birch",
      "name": "Bet v 1",
      "type": "M",
      "moleculeName": "Fagales, Group 1; Bet v 1-like",
      "latinName": "Betula verrucosa",
      "tissue": "Pollen",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Silver birch",
      "name": "Bet v 2",
      "type": "M",
      "moleculeName": "Profilin",
      "latinName": "Betula verrucosa",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Silver birch",
      "name": "Bet v 6",
      "type": "M",
      "moleculeName": "Isoflavone Reductase",
      "latinName": "Betula verrucosa",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Sugi",
      "name": "Cry j 1",
      "type": "M",
      "moleculeName": "Cupressaceae, Group 1; CCD-bearing Protein (XF); Pectate Lyase",
      "latinName": "Cryptomeria japonica",
      "tissue": "Pollen",
      "discription": "Specific allergen markers of allergy to pollen of Cupressaceae; Inhalation can cause symptoms such as rhinitis, conjunctivitis, rarely asthma, in the winter and early springtime. Some species have their pollinating time in fall."
    },
    {
      "commonName": "Tree of heaven",
      "name": "Ail a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Allanthus altissima",
      "tissue": "Pollen",
      "discription": "This is a moderate respiratory allergen with seasonal pollen-induced rhinitis/conjunctivitis (late spring/summer) and contact dermatitis risk from sap exposure. It has limited cross-reactivity.*"
    },
    {
      "commonName": "Walnut",
      "name": "Jug r_pollen",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Juglans regia",
      "tissue": "Pollen",
      "discription": "The positive test for walnut pollen, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Annual mercury",
      "name": "Mer a 1",
      "type": "M",
      "moleculeName": "Profilin",
      "latinName": "Mercurialis annua",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Hemp (CBD)",
      "name": "Can s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Cannabis sativa",
      "tissue": "Pollen",
      "discription": "The positive test for the marijuana, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Hemp",
      "name": "Can s 3",
      "type": "M",
      "moleculeName": "LTP",
      "latinName": "Cannabis sativa",
      "tissue": "Leaf",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Lamb's quarter",
      "name": "Che a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Chenopodium album",
      "tissue": "Pollen",
      "discription": "The positive test for the goosefoot, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Lamb's quarter",
      "name": "Che a 1",
      "type": "M",
      "moleculeName": "Ole e 1-like",
      "latinName": "Chenopodium album",
      "tissue": "Pollen",
      "discription": "Allergen marker of allergy to olive pollen, present in other Oleaceae (ash, privet) and pollen of other families, although the binding with specific IgE varies greatly among allergy subjects; it is present only in pollen and can cause symptoms such as rhinitis and asthma by inhalation, often severe depending on the level of exposure."
    },
    {
      "commonName": "Mugwort",
      "name": "Art v",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Artemisia vulgaris",
      "tissue": "Pollen",
      "discription": "The positive test for mugwort, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Mugwort",
      "name": "Art v 1",
      "type": "M",
      "moleculeName": "LTP; 9k-like; Defensin",
      "latinName": "Artemisia vulgaris",
      "tissue": "Pollen",
      "discription": "Specific allergen marker of allergy to the pollen of the genus Artemisia, and also of other Asteraceae; Inhalation can cause symptoms such as rhinitis, conjunctivitis, and asthma in late spring/summer/fall period."
    },
    {
      "commonName": "Mugwort",
      "name": "Art v 3",
      "type": "M",
      "moleculeName": "LTP; 9k-LTP",
      "latinName": "Artemisia vulgaris",
      "tissue": "Pollen",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Nettle",
      "name": "Urt d",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Urtica dioica",
      "tissue": "Pollen",
      "discription": "This is a minor respiratory allergen with summer pollen contributing to polysensitization (profilin-mediated cross-reactivity), non-allergic stinging reactions (dominant clinical presentation), and rare IgE-mediated contact urticaria in occupational settings.*"
    },
    {
      "commonName": "Pigweed",
      "name": "Ama r",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Amaranthus retroflexus",
      "tissue": "Pollen",
      "discription": "The positive test for the redroot amaranth, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Ragweed",
      "name": "Amb a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ambrosia artemisiifolia",
      "tissue": "Pollen",
      "discription": "The positive test for ragweed, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Ragweed",
      "name": "Amb a 1",
      "type": "M",
      "moleculeName": "Art v 1-like; Pectate Lyase",
      "latinName": "Ambrosia artemisiifolia",
      "tissue": "Pollen",
      "discription": "Specific allergen marker of allergy to ragweed pollen; Inhalation can cause symptoms such as rhinitis, conjunctivitis, asthma often severe in the summer/fall period."
    },
    {
      "commonName": "Ragweed",
      "name": "Amb a 4",
      "type": "M",
      "moleculeName": "Art v 1-like; Defensin",
      "latinName": "Ambrosia artemisiifolia",
      "tissue": "Pollen",
      "discription": "Specific allergen marker of allergy to the pollen of the genus Artemisia, and also of other Asteraceae; Inhalation can cause symptoms such as rhinitis, conjunctivitis, and asthma in late spring/summer/fall period."
    },
    {
      "commonName": "Ribwort",
      "name": "Pla l",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Plantago lanceolata",
      "tissue": "Pollen",
      "discription": "The positive test for the english plantain, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Ribwort",
      "name": "Pla l 1",
      "type": "M",
      "moleculeName": "Ole e 1-like",
      "latinName": "Plantago lanceolata",
      "tissue": "Pollen",
      "discription": "Allergen marker of allergy to olive pollen, present in other Oleaceae (ash, privet) and pollen of other families, although the binding with specific IgE varies greatly among allergy subjects; it is present only in pollen and can cause symptoms such as rhinitis and asthma by inhalation, often severe depending on the level of exposure."
    },
    {
      "commonName": "Russian thistle",
      "name": "Sal k",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Salsola kali",
      "tissue": "Pollen",
      "discription": "The positive test for the russian-thistle, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Russian thistle",
      "name": "Sal k 1",
      "type": "M",
      "moleculeName": "Pectin Methylesterase",
      "latinName": "Salsola kali",
      "tissue": "Pollen",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation, generally mild, throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Wall pellitory",
      "name": "Par j",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Parietaria judaica",
      "tissue": "Pollen",
      "discription": "This is a major allergenic weed with year-round respiratory allergies (rhinitis/asthma) and LTP-mediated food cross-reactivity (anaphylaxis risk). This has a high prevalence in Mediterranean urban areas.*"
    },
    {
      "commonName": "Wall pellitory",
      "name": "Par j 2",
      "type": "M",
      "moleculeName": "LTP; 11k-LTP",
      "latinName": "Parietaria judaica",
      "tissue": "Pollen",
      "discription": "Marker allergen of allergy to parietaria pollen. It causes symptoms by inhalation like conjunctivitis and rhinitis, bronchial asthma is very often associated, frequently severe, for a period starting at the beginning of spring ending in fall. It is not present in foods."
    },
    {
      "commonName": "Cat",
      "name": "Fel d 1",
      "type": "M",
      "moleculeName": "Fel d 1-related",
      "latinName": "Felis domesticus",
      "tissue": "Saliva",
      "discription": "Specific allergen marker of allergy to cat, also present in felines and dogs; Inhalation can cause symptoms such as rhinitis and asthma, even very severe, and skin symptoms (urticaria) by direct contact."
    },
    {
      "commonName": "Cat",
      "name": "Fel d 2",
      "type": "M",
      "moleculeName": "Serum Albumin",
      "latinName": "Felis domesticus",
      "tissue": "Dandruff, Serum, Urine",
      "discription": "Group of animal-derived allergens found in many tissues such as blood, muscle, milk, saliva, sweat; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation or ingestion, the symptoms are rarely severe. This allergen can not resist the prolonged cooking."
    },
    {
      "commonName": "Cat",
      "name": "Fel d 4",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Felis domesticus",
      "tissue": "Saliva, Dandruff",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Cat",
      "name": "Fel d 7",
      "type": "M",
      "moleculeName": "Calycin",
      "latinName": "Felis domesticus",
      "tissue": "Saliva",
      "discription": "Group of allergens derived from insects and mammals. They can cause respiratory symptoms such as rhinitis and asthma."
    },
    {
      "commonName": "Cattle",
      "name": "Bos d 2",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Bos domesticus",
      "tissue": "Dandruff",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Djungarian hamster",
      "name": "Phod s 1",
      "type": "M",
      "moleculeName": "Odorant-binding Protein",
      "latinName": "Phodopus sungorus",
      "tissue": "Saliva, Urine, Hair",
      "discription": "Group of allergens derived from animals present in the skin and in secretions; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "Dog",
      "name": "Can f 1",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Canis familiaris",
      "tissue": "Saliva, Dandruff",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Dog",
      "name": "Can f 2",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Canis familiaris",
      "tissue": "Saliva, Dandruff",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Dog",
      "name": "Can f 3",
      "type": "M",
      "moleculeName": "Serum Albumin",
      "latinName": "Canis familiaris",
      "tissue": "Saliva, Dandruff, Serum",
      "discription": "Group of animal-derived allergens found in many tissues such as blood, muscle, milk, saliva, sweat; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation or ingestion, the symptoms are rarely severe. This allergen can not resist the prolonged cooking."
    },
    {
      "commonName": "Dog",
      "name": "Can f 4",
      "type": "M",
      "moleculeName": "Odorant-binding Protein",
      "latinName": "Canis familiaris",
      "tissue": "Saliva, Dandruff",
      "discription": "Group of allergens derived from animals present in the skin and in secretions; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "Dog, male urine (incl. Can f 5)",
      "name": "Can f_male urine",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Canis familiaris",
      "tissue": "Urine",
      "discription": "The positive test for male dog urine (containing Can f 5 allergen), evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Dog",
      "name": "Can f 6",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Canis familiaris",
      "tissue": "Saliva, Dandruff",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Dog",
      "name": "Can f_Fd1",
      "type": "M",
      "moleculeName": "Fel d 1-related",
      "latinName": "Canis familiaris",
      "tissue": "Saliva, Dandruff",
      "discription": "Specific allergen marker of allergy to cat, also present in felines and dogs; Inhalation can cause symptoms such as rhinitis and asthma, even very severe, and skin symptoms (urticaria) by direct contact."
    },
    {
      "commonName": "Goat",
      "name": "Cap h_epithelia",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Capra hircus",
      "tissue": "Dandruff",
      "discription": "The positive test for goat dander, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Guinea pig",
      "name": "Cav p 1",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Cavia porcellus",
      "tissue": "Dandruff, Urine",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Horse",
      "name": "Equ c 1",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Equus caballus",
      "tissue": "Skin",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "Horse",
      "name": "Equ c 3",
      "type": "M",
      "moleculeName": "Serum Albumin",
      "latinName": "Equus caballus",
      "tissue": "Serum, Milk, Muscle, Skin",
      "discription": "Group of animal-derived allergens found in many tissues such as blood, muscle, milk, saliva, sweat; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation or ingestion, the symptoms are rarely severe. This allergen can not resist the prolonged cooking."
    },
    {
      "commonName": "Horse",
      "name": "Equ c 4",
      "type": "M",
      "moleculeName": "Latherin",
      "latinName": "Equus caballus",
      "tissue": "Saliva, Skin, Sweat",
      "discription": "Group of allergens derived from animals present in the skin and in secretions; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "Mouse",
      "name": "Mus m 1",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Mus musculus",
      "tissue": "Urine",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Pig",
      "name": "Sus d_epithelia",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Sus scrofa domestica",
      "tissue": "Dandruff",
      "discription": "Allergy to Sus d manifests as pork-cat syndrome, Alpha-gal syndrome (delayed anaphylaxis), or occupational asthma/rhinitis. Management requires tailored avoidance.*"
    },
    {
      "commonName": "Rabbit",
      "name": "Ory c 1",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Oryctolagus cuniculus",
      "tissue": "Saliva, Dandruff, Urine, Skin",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Rabbit",
      "name": "Ory c 2",
      "type": "M",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "This is a moderate inhalant allergen with primary respiratory effects (rhinitis/asthma). It is an ccupational risk for lab workers/veterinarians but limited cross-reactivity with other pets.*"
    },
    {
      "commonName": "Rabbit",
      "name": "Ory c 3",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Oryctolagus cuniculus",
      "tissue": "Dandruff, Urine, Hair",
      "discription": "Group of allergens derived from animals present in the skin and in secretions; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "Rat",
      "name": "Rat n",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Rattus norvegicus",
      "tissue": "Dandruff",
      "discription": "The positive test for rat epithelium, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Sheep",
      "name": "Ovi a_epithelia",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ovis aries",
      "tissue": "Dandruff, Hair",
      "discription": "This allergen is most relevant in occupational settings (farmers, textile workers). It may cause respiratory symptoms (rhinitis/asthma) with low cross-reactivity. It may be managed primarily with avoidance.*"
    },
    {
      "commonName": "Acarus siro",
      "name": "Aca s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Acarus siro",
      "tissue": "Whole Body",
      "discription": "The positive test for house dust mite, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "American cockroach",
      "name": "Per a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Periplaneta americana",
      "tissue": "Whole Body",
      "discription": "The positive test for cockroach, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "American cockroach",
      "name": "Per a 7",
      "type": "M",
      "moleculeName": "Tropomyosin",
      "latinName": "Periplaneta americana",
      "tissue": "Muscle",
      "discription": "Group of arthropod muscle proteins; They are present in crustaceans, sea and soil mollusks, insects and mites; depending on the route of exposure, the positivity for one of these allergens is rarely associated with mild symptoms by ingestion (itching of the mouth), intestinal, or cutaneous generalized ones; frequently it causes severe anaphylactic reactions; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma. This allergen is resistant to cooking."
    },
    {
      "commonName": "American house dust mite",
      "name": "Der f 1",
      "type": "M",
      "moleculeName": "Mites, Group 1; Cysteine Protease",
      "latinName": "Dermatophagoides farinae",
      "tissue": "Whole Body",
      "discription": "Group of allergens in mainly present in dust mites and fungi (mold); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; it causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "American house dust mite",
      "name": "Der f 2",
      "type": "M",
      "moleculeName": "Mites, Group 2",
      "latinName": "Dermatophagoides farinae",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to house dust mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if you are allergic to other specific markers of the mites. This protein is heat resistant and may be involved in the reactions due to ingestion of mite contaminated flour."
    },
    {
      "commonName": "Blomia tropicalis",
      "name": "Blo t 5",
      "type": "M",
      "moleculeName": "Mites, Group 5/21",
      "latinName": "Blomia tropicalis",
      "tissue": "Whole Body",
      "discription": "Group of allergens present in mites, from tropical and temperate areas; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if allergic to other specific markers of the mites."
    },
    {
      "commonName": "Blomia tropicalis",
      "name": "Blo t 10",
      "type": "M",
      "moleculeName": "Tropomyosin",
      "latinName": "Blomia tropicalis",
      "tissue": "Whole Body",
      "discription": "Group of arthropod muscle proteins; they are present in crustaceans, sea and land molluscs, insects and mites; depending on the exposure route, positivity for one of these allergens is rarely associated with mild ingestion symptoms (itching in the oral cavity), intestinal symptoms, or generalized skin symptoms; they frequently cause severe anaphylactic reactions; inhalation of this allergen can cause respiratory symptoms such as rhinitis and asthma. This allergen is resistant to cooking."
    },
    {
      "commonName": "Blomia tropicalis",
      "name": "Blo t 21",
      "type": "M",
      "moleculeName": "Mites, Group 5/21",
      "latinName": "Blomia tropicalis",
      "tissue": "Whole Body",
      "discription": "Group of allergens present in mites, from tropical and temperate areas; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if allergic to other specific markers of the mites."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 1",
      "type": "M",
      "moleculeName": "Mites, Group 1; Cysteine Protease",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Group of allergens in mainly present in dust mites and fungi (mold); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; it causes symptoms by inhalation as rhinitis and asthma, often severe."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 2",
      "type": "M",
      "moleculeName": "Mites, Group 2",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to house dust mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if you are allergic to other specific markers of the mites. This protein is heat resistant and may be involved in the reactions due to ingestion of mite contaminated flour."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 5",
      "type": "M",
      "moleculeName": "Mites, Group 5/21",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Group of allergens present in mites, from tropical and temperate areas; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if allergic to other specific markers of the mites."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 7",
      "type": "M",
      "moleculeName": "Mites, Group 7",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms can be more severe if allergic to other specific markers of the mites."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 10",
      "type": "M",
      "moleculeName": "Tropomyosin; Mites, Group 10",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Group of allergens belonging to the family of tropomyosin. Inhalation can cause symptoms such as rhinitis."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 11",
      "type": "M",
      "moleculeName": "Paromyosin; Mites, Group 11",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "It is a minor but clinically relevant HDM allergen with respiratory effects (rhinitis/asthma), especially in tropical regions. Has cross-reactivity with other mites (Der f 11, Blo t 11).*"
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 20",
      "type": "M",
      "moleculeName": "Arginine Kinase; Mites, Group 20",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Group of proteins from arthropods; present in crustacean, but also in insects and mites; depending on the route of exposure, the positivity for one of these allergens is associated with mild symptoms by ingestion (itching of the oral cavity), or intestinal, or generalized cutaneous; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 21",
      "type": "M",
      "moleculeName": "Mites, Group 5/21",
      "latinName": "Dermatophagoides pteronyssinus",
      "tissue": "Whole Body",
      "discription": "Group of allergens present in mites, from tropical and temperate areas; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if allergic to other specific markers of the mites."
    },
    {
      "commonName": "European house dust mite",
      "name": "Der p 23",
      "type": "M",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "Specific allergen marker of allergy to house dust mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms can be more severe if allergic to other specific markers of the mites."
    },
    {
      "commonName": "German cockroach",
      "name": "Bla g 1",
      "type": "M",
      "moleculeName": "Cockroaches, Group 1",
      "latinName": "Blattella germanica",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to cockroaches; Inhalation can cause symptoms such as rhinitis or asthma, even severe, potentially throughout the year."
    },
    {
      "commonName": "German cockroach",
      "name": "Bla g 2",
      "type": "M",
      "moleculeName": "Aspartic Protease",
      "latinName": "Blattella germanica",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to cockroaches; Inhalation can cause symptoms such as rhinitis or asthma, even severe, potentially throughout the year."
    },
    {
      "commonName": "German cockroach",
      "name": "Bla g 4",
      "type": "M",
      "moleculeName": "Calycin; Lipocalin",
      "latinName": "Blattella germanica",
      "tissue": "Whole Body",
      "discription": "Group of allergens derived from insects and mammals. They can cause respiratory symptoms such as rhinitis and asthma."
    },
    {
      "commonName": "German cockroach",
      "name": "Bla g 5",
      "type": "M",
      "moleculeName": "GST",
      "latinName": "Blattella germanica",
      "tissue": "Whole Body",
      "discription": "This is a major cockroach allergen with strong links to asthma severity, especially in urban settings. It has a cross-reactivity with other cockroach GSTs (e.g., Per a 5).*"
    },
    {
      "commonName": "German cockroach",
      "name": "Bla g 9",
      "type": "M",
      "moleculeName": "Arginine Kinase",
      "latinName": "Blattella germanica",
      "tissue": "Muscle",
      "discription": "Group of proteins from arthropods; present in crustacean, but also in insects and mites; depending on the route of exposure, the positivity for one of these allergens is associated with mild symptoms by ingestion (itching of the oral cavity), or intestinal, or generalized cutaneous; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma."
    },
    {
      "commonName": "Glycyphagus domesticus",
      "name": "Gly d 2",
      "type": "M",
      "moleculeName": "Mites, Group 2",
      "latinName": "Glycyphagus domesticus",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to house dust mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if you are allergic to other specific markers of the mites. This protein is heat resistant and may be involved in the reactions due to ingestion of mite contaminated flour."
    },
    {
      "commonName": "Lepidoglyphus destructor",
      "name": "Lep d 2",
      "type": "M",
      "moleculeName": "Mites, Group 2",
      "latinName": "Lepidoglyphus destructor",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to house dust mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if you are allergic to other specific markers of the mites. This protein is heat resistant and may be involved in the reactions due to ingestion of mite contaminated flour."
    },
    {
      "commonName": "Tyrophagus putrescentiae",
      "name": "Tyr p",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Tyrophagus putrescentiae",
      "tissue": "Whole Body",
      "discription": "The positive test for dust mite, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Tyrophagus putrescentiae",
      "name": "Tyr p 2",
      "type": "M",
      "moleculeName": "Mites, Group 2",
      "latinName": "Tyrophagus putrescentiae",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to house dust mites; Inhalation can cause symptoms such as rhinitis or asthma, potentially throughout the year. Symptoms may be more severe if you are allergic to other specific markers of the mites. This protein is heat resistant and may be involved in the reactions due to ingestion of mite contaminated flour."
    },
    {
      "commonName": "Alternaria alternata",
      "name": "Alt a 1",
      "type": "M",
      "moleculeName": "Alt a 1-related",
      "latinName": "Alternaria alternata",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of Alternaria, a mold predominantly present in the outdoor environment. The spores that contain the allergen are dispersed almost all year long, but increase a lot in the summertime. It can cause symptoms by inhalation, as rhinitis, conjunctivitis, asthma."
    },
    {
      "commonName": "Alternaria alternata",
      "name": "Alt a 6",
      "type": "M",
      "moleculeName": "Enolase",
      "latinName": "Alternaria alternata",
      "tissue": "Whole Body",
      "discription": "Group of allergens present in many fungi (molds). It can cause symptoms from inhalation as rhinitis, conjunctivitis, asthma all year long. Similar proteins have been described as allergens in latex and in many other sources like allergenic foods"
    },
    {
      "commonName": "Aspergillus fumigatus",
      "name": "Asp f 1",
      "type": "M",
      "moleculeName": "Ribotoxin",
      "latinName": "Aspergillus fumigatus",
      "tissue": "Whole Body",
      "discription": "Specific allergen for allergy to Aspergillus, a mould present outdoor and indoor; It can cause severe respiratory symptoms (asthma) all year long."
    },
    {
      "commonName": "Aspergillus fumigatus",
      "name": "Asp f 3",
      "type": "M",
      "moleculeName": "Peroxisomal Protein",
      "latinName": "Aspergillus fumigatus",
      "tissue": "Whole Body",
      "discription": "Group of allergens primarily present in Aspergillus species, but also in many other fungi (molds). It can cause symptoms from inhalation as rhinitis, conjunctivitis, asthma all year long."
    },
    {
      "commonName": "Aspergillus fumigatus",
      "name": "Asp f 4",
      "type": "M",
      "moleculeName": "Fungal Group 4",
      "latinName": "Aspergillus fumigatus",
      "tissue": "Whole Body",
      "discription": "Group of allergens present in many fungi (molds). It can cause symptoms from inhalation as rhinitis, conjunctivitis, asthma all year long. Similar proteins have been described as allergens in latex and in many other sources like allergenic foods."
    },
    {
      "commonName": "Aspergillus fumigatus",
      "name": "Asp f 6",
      "type": "M",
      "moleculeName": "SOD; Fe/Mn-SOD",
      "latinName": "Aspergillus fumigatus",
      "tissue": "Whole Body",
      "discription": "Group of allergens present mainly in many mycophytes (molds), but also in foods and latex. It can mainly cause symptoms from inhalation of fungal spores, such as rhinitis and asthma. Atopic dermatitis has been associated with this allergen."
    },
    {
      "commonName": "Cladosporium herbarum",
      "name": "Cla h",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Cladosporium herbarum",
      "tissue": "Whole Body",
      "discription": "The positive test for cladosporium, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Cladosporium herbarum",
      "name": "Cla h 8",
      "type": "M",
      "moleculeName": "Mannitol Dehydrogenase",
      "latinName": "Cladosporium herbarum",
      "tissue": "Whole Body",
      "discription": "Allergen found in many fungi (molds) that produce spores outdoor and indoor; it can cause symptoms by inhalation such as rhinitis and asthma, potentially all year long."
    },
    {
      "commonName": "Malassezia sympodialis",
      "name": "Mala s 5",
      "type": "M",
      "moleculeName": "SOD; Fe/Mn-SOD",
      "latinName": "Malassezia sympodialis",
      "tissue": "Whole Body",
      "discription": "Specific allergen for allergy to Malassezia, a fungi present on the skin; It is associated to atopic dermatitis."
    },
    {
      "commonName": "Malassezia sympodialis",
      "name": "Mala s 6",
      "type": "M",
      "moleculeName": "Oxidoreductase",
      "latinName": "Malassezia sympodialis",
      "tissue": "Whole Body",
      "discription": "Group of allergens commonly present in many plant and fungi species, it can be present also in mites; It can cause symptoms by inhalation or ingestion; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects."
    },
    {
      "commonName": "Malassezia sympodialis",
      "name": "Mala s 11",
      "type": "M",
      "moleculeName": "Cyclophilin",
      "latinName": "Malassezia sympodialis",
      "tissue": "Whole Body",
      "discription": "Group of allergens mainly present in many fungi (mold), but also in food and latex. It can cause symptoms primarily by inhalation of fungal spores, such as rhinitis and asthma. Atopic dermatitist has been associated with this allergen."
    },
    {
      "commonName": "Penicilium chrysogenum",
      "name": "Pen ch",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Penicillium chrysogenum",
      "tissue": "Whole Body",
      "discription": "The positive test for penicillium, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Common wasp venom",
      "name": "Ves v",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Vespula vulgaris",
      "tissue": "Venom",
      "discription": "The positive test for wasp, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Common wasp venom",
      "name": "Ves v 1",
      "type": "M",
      "moleculeName": "Phospholipase A1",
      "latinName": "Vespula vulgaris",
      "tissue": "Venom",
      "discription": "It is the key allergenic trigger in common wasp venom, associated with life-threatening anaphylaxis in sensitized individuals. It is a species-specific diagnosis (no cross-reactivity with bees).*"
    },
    {
      "commonName": "Common wasp venom",
      "name": "Ves v 5",
      "type": "M",
      "moleculeName": "Antigen 5",
      "latinName": "Vespula vulgaris",
      "tissue": "Venom",
      "discription": "Specific allergen marker of allergy to the wasp venom; the wasp sting can cause severe reactions at the injection site, but also generalized reactions up to anaphylaxis."
    },
    {
      "commonName": "Fire ant venom",
      "name": "Sol spp.",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Solenopsis invicta",
      "tissue": "Venom",
      "discription": "The positive test for imported fire ant, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Honey bee venom",
      "name": "Api m",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Apis mellifera",
      "tissue": "Venom",
      "discription": "Specific allergen marker of allergy to bee venom; the bee sting can cause severe reactions at the injection site, but also generalized reactions up to anaphylaxis."
    },
    {
      "commonName": "Honey bee venom",
      "name": "Api m 1",
      "type": "M",
      "moleculeName": "Phospholipase A2; CCD-bearing Protein (XF)",
      "latinName": "Apis mellifera",
      "tissue": "Venom",
      "discription": "Specific allergen marker of allergy to bee venom; the bee sting can cause severe reactions at the injection site, but also generalized reactions up to anaphylaxis."
    },
    {
      "commonName": "Honey bee venom",
      "name": "Api m 10",
      "type": "M",
      "moleculeName": "Icarapin",
      "latinName": "Apis mellifera",
      "tissue": "Venom",
      "discription": "Specific allergen marker of allergy to bee venom; the bee sting can cause severe reactions at the injection site, but also generalized reactions up to anaphylaxis."
    },
    {
      "commonName": "Long-headed wasp venom",
      "name": "Dol spp. ",
      "type": "E",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "The positive test for wasp, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Paper wasp venom",
      "name": "Pol d",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Polistes dominulus",
      "tissue": "Venom",
      "discription": "The positive test for wasp, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Paper wasp venom",
      "name": "Pol d 5",
      "type": "M",
      "moleculeName": "Antigen 5",
      "latinName": "Polistes dominulus",
      "tissue": "Venom",
      "discription": "Specific allergen marker of allergy to the wasp venom; the wasp sting can cause severe reactions at the injection site, but also generalized reactions up to anaphylaxis."
    },
    {
      "commonName": "Barley",
      "name": "Hor v",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Hordeum vulgare",
      "tissue": "Seed",
      "discription": "The positive test for barley, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Buckwheat",
      "name": "Fag e",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Fagopyrum esculentum",
      "tissue": "Seed",
      "discription": "The positive test for buckwheat, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Buckwheat",
      "name": "Fag e 2",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Fagopyrum esculentum",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Corn, cereal",
      "name": "Zea m",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Zea mays",
      "tissue": "Seed",
      "discription": "The positive test for corn, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Corn, cereal",
      "name": "Zea m 14",
      "type": "M",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Cultivated rye",
      "name": "Sec c_flour",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Secale cereale",
      "tissue": "Seed",
      "discription": "The positive test for rye, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Fenugreek seeds",
      "name": "Tri fo",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Trigonella foenum-graecum",
      "tissue": "Seed",
      "discription": "The positive test for fenugreek, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Millet",
      "name": "Pan m",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Panicum miliaceum",
      "tissue": "Seed",
      "discription": "The positive test for proso millet, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Oat",
      "name": "Ave s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Avena sativa",
      "tissue": "Seed",
      "discription": "The positive test for oat, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Poppy seed",
      "name": "Pap s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Papaver somniferum",
      "tissue": "Seed",
      "discription": "The positive test for opium poppy seeds, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Poppy seed",
      "name": "Pap s 2S Albumin",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Papaver somniferum",
      "tissue": "Seed",
      "discription": "This is a rare but potent seed allergen with risk of systemic reactions (anaphylaxis in sensitive individuals). There may be cross-reactivity with mustard/rapeseed (2S albumin family).*"
    },
    {
      "commonName": "Pumpkin seed",
      "name": "Cuc p",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Cucurbita maxima",
      "tissue": "Seed",
      "discription": "The positive test for pumpkin seeds, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Quinoa",
      "name": "Che q",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Chenopodium quinoa",
      "tissue": "Seed",
      "discription": "The positive test for quinoa, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Rice",
      "name": "Ory s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Oryza sativa",
      "tissue": "Seed",
      "discription": "The positive test for rice, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Sesame",
      "name": "Ses i",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Sesamum indicum",
      "tissue": "Seed",
      "discription": "The positive test for sesame, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Sesame",
      "name": "Ses i 1",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Sesamum indicum",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Spelt",
      "name": "Tri s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Triticum aestivum ssp. spelta",
      "tissue": "Seed",
      "discription": "The positive test for spelt, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Sunflower seed",
      "name": "Hel a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Helianthus annuus",
      "tissue": "Seed",
      "discription": "The positive test for sunflower seeds, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Wheat",
      "name": "Tri a 14",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Triticum aestivum",
      "tissue": "Seed",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Wheat",
      "name": "Tri a 19",
      "type": "M",
      "moleculeName": "Gliadin, omega-Gliadin",
      "latinName": "Triticum aestivum",
      "tissue": "Seed",
      "discription": "Allergenic fraction, containing molecules with different structures present in wheat and other cereals containing gluten (rye, barley, oat); Exposure by ingestion can cause intestinal symptoms or severe generalized ones; it is the cause of the food-dependent exercise-induced anaphylaxis."
    },
    {
      "commonName": "Wheat",
      "name": "Tri aA_TI",
      "type": "M",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "Group of proteins with a wide distribution in different allergenic sources, mainly foods. The IgE positivity, however, is often restricted to molecules coming from the different tissues (e.g. seeds or eggs). They cause symptoms such as urticaria by ingestion."
    },
    {
      "commonName": "Camel's milk",
      "name": "Cam d",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Camelus dromedarius",
      "tissue": "Milk",
      "discription": "The positive test for camel's milk, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Cow's milk",
      "name": "Bos d_milk",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Bos domesticus",
      "tissue": "Milk",
      "discription": "The positive test for cow's milk, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Cow's milk",
      "name": "Bos d 4",
      "type": "M",
      "moleculeName": "alpha-Lactalbumin",
      "latinName": "Bos domesticus",
      "tissue": "Milk",
      "discription": "Specific allergen marker of allergy to mammal's milk; It can cause symptoms both by ingestion in the bowel, but also as skin (urticaria and eczema), as well as generalized reactions."
    },
    {
      "commonName": "Cow's milk",
      "name": "Bos d 5",
      "type": "M",
      "moleculeName": "beta-Lactoglobulin, Lipocalin",
      "latinName": "Bos domesticus",
      "tissue": "Milk",
      "discription": "Specific allergen marker of allergy to most of the mammal's milk; It can cause symptoms both by ingestion in the bowel, but also as skin (urticaria and eczema), as well as severe generalized reactions up to anaphylaxis. It is not resistent to cooking."
    },
    {
      "commonName": "Cow's milk",
      "name": "Bos d 8",
      "type": "M",
      "moleculeName": "Casein: alphaS1-Casein; alphaS2-Casein; beta-Casein; kappa-Casein",
      "latinName": "Bos domesticus",
      "tissue": "Milk",
      "discription": "Specific allergen marker of allergy to mammal's milk; It can cause symptoms both by ingestion in the bowel, but also as skin (urticaria and eczema), as well as generalized reactions."
    },
    {
      "commonName": "Egg white",
      "name": "Gal d_white",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Gallus domesticus",
      "tissue": "Egg",
      "discription": "The positive test for hen's egg white, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Egg white",
      "name": "Gal d 1",
      "type": "M",
      "moleculeName": "Ovomucoid; Trypsin Inhibitor",
      "latinName": "Gallus domesticus",
      "tissue": "Egg",
      "discription": "Group of proteins with a wide distribution in different allergenic sources, mainly foods. The IgE positivity, however, is often restricted to molecules coming from the different tissues (e.g. seeds or eggs). They cause symptoms such as urticaria by ingestion."
    },
    {
      "commonName": "Egg white",
      "name": "Gal d 2",
      "type": "M",
      "moleculeName": "Ovalbumin",
      "latinName": "Gallus domesticus",
      "tissue": "Egg",
      "discription": "Specific allergen marker of egg allergy, present in all edible eggs;It can cause symptoms both by ingestion in the bowel, and in the skin (urticaria and eczema), and rarely generalized reactions."
    },
    {
      "commonName": "Egg white",
      "name": "Gal d 3",
      "type": "M",
      "moleculeName": "Ovotransferrin",
      "latinName": "Gallus domesticus",
      "tissue": "Egg",
      "discription": "Specific allergen marker of egg allergy, present in all edible eggs; It can cause symptoms both by ingestion in the bowel, and in the skin (urticaria and eczema), and rarely generalized reactions."
    },
    {
      "commonName": "Egg white",
      "name": "Gal d 4",
      "type": "M",
      "moleculeName": "Lysozyme",
      "latinName": "Gallus domesticus",
      "tissue": "Egg",
      "discription": "Group of allergens present in the hen's egg and other edible species. This allergen rarely causes severe symptoms, but it can have other routes of exposure because it is used as a drug and as preservative for foods."
    },
    {
      "commonName": "Egg yolk",
      "name": "Gal d_yolk",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Gallus domesticus",
      "tissue": "Egg",
      "discription": "The positive test for hen's egg yolk, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Egg yolk",
      "name": "Gal d 5",
      "type": "M",
      "moleculeName": "Serum Albumin; Livetin",
      "latinName": "Gallus domesticus",
      "tissue": "Serum, Egg",
      "discription": "Specific allergen marker of egg allergy, present in all edible eggs as well as in feathers and serum; It can cause symptoms both by ingestion in the bowel, and in the skin (urticaria and eczema), and rarely generalized reactions; it can cause symptoms by inhalation like rhinitis and asthma."
    },
    {
      "commonName": "Goat's milk",
      "name": "Cap h_milk",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Capra hircus",
      "tissue": "Milk",
      "discription": "The positive test for goat's milk, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Mare's milk",
      "name": "Equ c_milk",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Equus caballus",
      "tissue": "Milk",
      "discription": "The positive test for mare's milk, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Sheep's milk",
      "name": "Ovi a_milk",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ovis aries",
      "tissue": "Milk",
      "discription": "The positive test for sheep's milk, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Apple",
      "name": "Mal d 1",
      "type": "M",
      "moleculeName": "Fagales-related, Group 1; Bet v 1-like",
      "latinName": "Malus domestica",
      "tissue": "Fruit",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Apple",
      "name": "Mal d 2",
      "type": "M",
      "moleculeName": "Thaumatin",
      "latinName": "Malus domestica",
      "tissue": "Fruit",
      "discription": "Group of allergens present in plant foods that can cause local symptoms (itching of the oral cavity), rarely severe and generalized, also by ingestion of one or more foods."
    },
    {
      "commonName": "Apple",
      "name": "Mal d 3",
      "type": "M",
      "moleculeName": "LTP",
      "latinName": "Malus domestica",
      "tissue": "Fruit",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Avocado",
      "name": "Pers a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Persea americana",
      "tissue": "Fruit",
      "discription": "The positive test for avocado, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Banana",
      "name": "Mus a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Musa acuminata",
      "tissue": "Fruit",
      "discription": "This (banana) allergy presents as mild OAS (profilin-mediated) or severe systemic reactions (nsLTP-mediated) and strong linkage to latex-fruit syndrome (Mus a 1).*"
    },
    {
      "commonName": "Blueberry",
      "name": "Vac m",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Vaccinium myrtillus",
      "tissue": "Fruit",
      "discription": "The positive test for black mulberry, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Cherry",
      "name": "Pru av",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Prunus avium",
      "tissue": "Fruit",
      "discription": NaN
    },
    {
      "commonName": "Fig",
      "name": "Fic c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ficus carica",
      "tissue": "Fruit, Latex",
      "discription": "The positive test for the common fig, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Grape",
      "name": "Vit v 1",
      "type": "M",
      "moleculeName": "LTP",
      "latinName": "Vitis vinifera",
      "tissue": "Fruit",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Kiwi",
      "name": "Act d 1",
      "type": "M",
      "moleculeName": "Cysteine Protease, Food",
      "latinName": "Actinidia deliciosa",
      "tissue": "Fruit",
      "discription": "Specific allergen marker of allergy to some fruits; It can cause symptoms by ingestion, locally (mouth itching), but also generalized and severe (urticaria and anaphylaxis)."
    },
    {
      "commonName": "Kiwi",
      "name": "Act d 2",
      "type": "M",
      "moleculeName": "Thaumatin",
      "latinName": "Actinidia deliciosa",
      "tissue": "Fruit",
      "discription": "Group of allergens present in plant foods that can cause local symptoms (itching of the oral cavity), rarely severe and generalized, also by ingestion of one or more foods."
    },
    {
      "commonName": "Kiwi",
      "name": "Act d 5",
      "type": "M",
      "moleculeName": "Kiwellin",
      "latinName": "Actinidia deliciosa",
      "tissue": "Fruit",
      "discription": "Kiwi allergy presents as mild OAS (PR-10/profilin) or severe systemic reactions (nsLTP). It has a strong cross-reactivity within Rosaceae fruits and birch pollen.*"
    },
    {
      "commonName": "Kiwi",
      "name": "Act d 10",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Actinidia deliciosa",
      "tissue": "Fruit",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Mango",
      "name": "Man i",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Mangifera indica",
      "tissue": "Fruit",
      "discription": "Mangifera indica allergy manifests as OAS (PR-10/profilin) or severe systemic reactions (nsLTP) and contact dermatitis via urushiol analogs. It has a strong latex-fruit cross-reactivity."
    },
    {
      "commonName": "Muskmelon",
      "name": "Cuc m 2",
      "type": "M",
      "moleculeName": "Profilin",
      "latinName": "Cucumis melo",
      "tissue": "Fruit",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Orange",
      "name": "Cit s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Citrus sinensis",
      "tissue": "Fruit",
      "discription": "The positive test for sweet orange, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Papaya",
      "name": "Car p",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Carica papaya",
      "tissue": "Fruit",
      "discription": "The positive test for papaya, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Peach",
      "name": "Pru p 3",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Prunus persica",
      "tissue": "Fruit",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Pear",
      "name": "Pyr c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Pyrus communis",
      "tissue": "Fruit",
      "discription": "The positive test for pear, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Strawberry",
      "name": "Fra a 1+3",
      "type": "M-Mix",
      "moleculeName": "(-)",
      "latinName": "Fragaria ananassa",
      "tissue": "Fruit",
      "discription": "Strawberry allergy is bimodal. Reported with Fra a 3 + cofactors (alcohol, NSAIDs).\nMild OAS (Fra a 1) \u2013 Linked to birch pollen. Severe systemic (Fra a 3) is prevalent in southern Europe."
    },
    {
      "commonName": "Almond",
      "name": "Pru du",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Prunus dulcis",
      "tissue": "Seed",
      "discription": "The positive test for almond, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Brazil nut",
      "name": "Ber e",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Bertholletia excelsa",
      "tissue": "Seed",
      "discription": "The positive test for brazil nut, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Brazil nut",
      "name": "Ber e 1",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Bertholletia excelsa",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Cashew",
      "name": "Ana o",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Anacardium occidentale",
      "tissue": "Seed",
      "discription": "The positive test for cashewnut, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Cashew",
      "name": "Ana o 2",
      "type": "M",
      "moleculeName": "11S Globulin",
      "latinName": "Anacardium occidentale",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group present in other seeds, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), or intestinal, and generalized cutaneous ones; not rarely it can causes severe anaphylactic reactions."
    },
    {
      "commonName": "Cashew",
      "name": "Ana o 3",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Anacardium occidentale",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Chickpea",
      "name": "Cic a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Cicer arietinum",
      "tissue": "Seed",
      "discription": "The positive test for chickpeas, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Green bean",
      "name": "Pha v",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Phaseolus vulgaris",
      "tissue": "Seed",
      "discription": "The positive test for kidney beans, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Hazelnut",
      "name": "Cor a 1.0401",
      "type": "M",
      "moleculeName": "Fagales, Group 1; Fagales-related, Group 1; Bet v 1-like",
      "latinName": "Corylus avellana",
      "tissue": "Pollen, Seed",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Hazelnut",
      "name": "Cor a 8",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Corylus avellana",
      "tissue": "Seed",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Hazelnut",
      "name": "Cor a 9",
      "type": "M",
      "moleculeName": "11S Globulin",
      "latinName": "Corylus avellana",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group present in other seeds, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), or intestinal, and generalized cutaneous ones; not rarely it can causes severe anaphylactic reactions."
    },
    {
      "commonName": "Hazelnut",
      "name": "Cor a 11",
      "type": "M",
      "moleculeName": "7S Vicilin",
      "latinName": "Corylus avellana",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones; not rarely it causes severe anaphylactic reactions."
    },
    {
      "commonName": "Hazelnut",
      "name": "Cor a 14",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Corylus avellana",
      "tissue": "Seed",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Lentil",
      "name": "Len c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Lens culinaris",
      "tissue": "Seed",
      "discription": "The positive test for lentils, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Lupine seed",
      "name": "Lup a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Lupinus albus",
      "tissue": "Seed",
      "discription": "The positive test for lupin, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Macadamia",
      "name": "Mac inte",
      "type": "E",
      "moleculeName": "2S Albumin",
      "latinName": "Macadamia integrifolia",
      "tissue": "Seed, Nut",
      "discription": "The positive test for macadamia nuts, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Macadamia",
      "name": "Mac i 2S Albumin",
      "type": "M",
      "moleculeName": "///",
      "latinName": "Macadamia integrifolia",
      "tissue": "Seed, Nut",
      "discription": "Macadamia albumin allergy is uncommon but potentially severe, with risk of anaphylaxis (2S albumin-mediated). Possible cross-reactivity with walnut/hazelnut.*"
    },
    {
      "commonName": "Pea",
      "name": "Pis s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Pisum sativum",
      "tissue": "Seed",
      "discription": "The positive test for peas, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 1",
      "type": "M",
      "moleculeName": "7S Vicilin; CCD-bearing Protein (XF)",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "Marker of reactivity to carbohydrates of plant and insects glycoproteins. When positiveis associated with the positivity of glycoprotein allergens. It has great relevance in the interpretation of diagnostic tests, but has virtually no clinically impact, unless an IgE reactivity to the protein is associated. A positive result for this marker can generate positive results to allergen extracts derived from plants and insects."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 2",
      "type": "M",
      "moleculeName": "25 Albumin",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 3",
      "type": "M",
      "moleculeName": "Trypsin Inhibator; 115 Globulin",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "Group of proteins with a wide distribution in different allergenic sources, mainly foods. The IgE positivity, however, is often restricted to molecules coming from the different tissues (e.g. seeds or eggs). They cause symptoms such as urticaria by ingestion."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 6",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 8",
      "type": "M",
      "moleculeName": "Fagales-related, Group 1; Bet v 1-like",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 9",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Peanut",
      "name": "Ara h 15",
      "type": "M",
      "moleculeName": "Oleosin",
      "latinName": "Arachis hypogaea",
      "tissue": "Seed",
      "discription": "This is a minor but stable peanut allergen with potential role in peanut oil reactions. It has a limited standalone clinical impact (usually co-occurs with major allergen sensitization).*"
    },
    {
      "commonName": "Pecan",
      "name": "Car i",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Carya illinoensis",
      "tissue": "Seed, Nut",
      "discription": "The positive test for pecan, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Pistachio",
      "name": "Pis v 1",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Pistacia vera",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Pistachio",
      "name": "Pis v 2",
      "type": "M",
      "moleculeName": "11S Globulin",
      "latinName": "Pistacia vera",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group present in other seeds, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), or intestinal, and generalized cutaneous ones; not rarely it can causes severe anaphylactic reactions."
    },
    {
      "commonName": "Pistachio",
      "name": "Pis v 3",
      "type": "M",
      "moleculeName": "7S Vicilin",
      "latinName": "Pistacia vera",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones; not rarely it causes severe anaphylactic reactions."
    },
    {
      "commonName": "Soy",
      "name": "Gly m 4",
      "type": "M",
      "moleculeName": "Fagales-related, Group 1; Bet v 1-like",
      "latinName": "Glycine max",
      "tissue": "Seed",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Soy",
      "name": "Gly m 5",
      "type": "M",
      "moleculeName": "7S Vicilin",
      "latinName": "Glycine max",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones; not rarely it causes severe anaphylactic reactions."
    },
    {
      "commonName": "Soy",
      "name": "Gly m 6",
      "type": "M",
      "moleculeName": "11S Globulin",
      "latinName": "Glycine max",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group present in other seeds, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), or intestinal, and generalized cutaneous ones; not rarely it can causes severe anaphylactic reactions."
    },
    {
      "commonName": "Soy",
      "name": "Gly m 8",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Glycine max",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Walnut",
      "name": "Jug r 1",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Juglans regia",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Walnut",
      "name": "Jug r 2",
      "type": "M",
      "moleculeName": "7S Vicilin; CCD-bearing Protein (XF)",
      "latinName": "Juglans regia",
      "tissue": "Seed",
      "discription": "Marker of reactivity to carbohydrates of plant and insects glycoproteins. When positiveis associated with the positivity of glycoprotein allergens. It has great relevance in the interpretation of diagnostic tests, but has virtually no clinically impact, unless an IgE reactivity to the protein is associated. A positive result for this marker can generate positive results to allergen extracts derived from plants and insects."
    },
    {
      "commonName": "Walnut",
      "name": "Jug r 3",
      "type": "M",
      "moleculeName": "LTP, 9k-LTP",
      "latinName": "Juglans regia",
      "tissue": "Seed",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Walnut",
      "name": "Jug r 4",
      "type": "M",
      "moleculeName": "11S Globulin",
      "latinName": "Juglans regia",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group present in other seeds, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), or intestinal, and generalized cutaneous ones; not rarely it can causes severe anaphylactic reactions."
    },
    {
      "commonName": "Walnut",
      "name": "Jug r 6",
      "type": "M",
      "moleculeName": "2S Vicilin",
      "latinName": "Juglans regia",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones; not rarely it causes severe anaphylactic reactions."
    },
    {
      "commonName": "Beef",
      "name": "Bos d_meat",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Bos domesticus",
      "tissue": "Muscle",
      "discription": "The positive test for beef, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Beef",
      "name": "Bos d 6",
      "type": "M",
      "moleculeName": "Serum Albumin",
      "latinName": "Bos domesticus",
      "tissue": "Dandruff, Serum, Skin, Muscle",
      "discription": "Group of animal-derived allergens found in many tissues such as blood, muscle, milk, saliva, sweat; the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation or ingestion, the symptoms are rarely severe. This allergen can not resist the prolonged cooking."
    },
    {
      "commonName": "Chicken",
      "name": "Gal d_meat",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Gallus domesticus",
      "tissue": "Muscle",
      "discription": "The positive test for chicken meat, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Horse",
      "name": "Equ c_meat",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Equus caballus",
      "tissue": "Muscle",
      "discription": "The positive test for horse meat, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "House cricket",
      "name": "Ach d",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Acheta domesticus",
      "tissue": "Whole Body",
      "discription": "The positive test for the house cricket, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Lamb",
      "name": "Ovi a_meat",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ovis aries",
      "tissue": "Muscle",
      "discription": "The positive test for lamb, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Mealworm",
      "name": "Ten m ",
      "type": "E",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "The positive test for the yellow mealworm, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Migratory locust",
      "name": "Loc m",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Locusta migratoria",
      "tissue": "Whole Body",
      "discription": "The positive test for the migratory locust, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Pig",
      "name": "Sus d_meat",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Sus scrofa domestica",
      "tissue": "Muscle",
      "discription": "The positive test for pork, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Pig",
      "name": "Sus d 1",
      "type": "M",
      "moleculeName": "Serum Albumin",
      "latinName": "Sus scrofa domestica",
      "tissue": "Serum, Urine, Milk",
      "discription": "This mediates three distinct clinical scenarios: Pork-cat syndrome (most common presentation), occupational respiratory disease, and gelatin/vaccine reactions. It is advisable to test for Fel d 2 when evaluating pork allergy.*"
    },
    {
      "commonName": "Rabbit",
      "name": "Ory_meat",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Oryctolagus cuniculus",
      "tissue": "Muscle",
      "discription": "The positive test for rabbit meat, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Turkey",
      "name": "Mel g",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Meleagris gallopavo",
      "tissue": "Muscle",
      "discription": "The positive test for turkey meat, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Anisakis simplex",
      "name": "Ani s 1",
      "type": "M",
      "moleculeName": "Serine protease inhibitor",
      "latinName": "Anisakis simplex",
      "tissue": "Whole Body",
      "discription": "Specific allergen marker of allergy to anisakis, a fish parasite; not always present in all fish; can cause intestinal symptoms, but also generalized reactions up to anaphylaxis."
    },
    {
      "commonName": "Anisakis simplex",
      "name": "Ani s 3",
      "type": "M",
      "moleculeName": "Tropomyosin",
      "latinName": "Anisakis simplex",
      "tissue": "Muscle",
      "discription": "Group of arthropod muscle proteins; They are present in crustaceans, sea and soil mollusks, insects and mites; depending on the route of exposure, the positivity for one of these allergens is rarely associated with mild symptoms by ingestion (itching of the mouth), intestinal, or cutaneous generalized ones; frequently it causes severe anaphylactic reactions; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma. This allergen is resistant to cooking."
    },
    {
      "commonName": "Atlantic cod",
      "name": "Gad m",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Gadus morhua",
      "tissue": "Muscle",
      "discription": "The positive test for cod, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Atlantic cod",
      "name": "Gad m 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Gadus morhua",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Atlantic cod",
      "name": "Gad m 2+3",
      "type": "M-Mix",
      "moleculeName": "(-)",
      "latinName": "Gadus morhua",
      "tissue": "Muscle",
      "discription": "The clinical significance of Gad m 2 and Gad m 3 is primarily associated with the risk of allergic reactions through ingestion and inhalation of Atlantic cod. The clinical manifestations can range from mild symptoms (e.g., hives) to severe, life-threatening reactions (e.g., anaphylaxis). Awareness and avoidance are crucial in managing cod fish allergies.*"
    },
    {
      "commonName": "Atlantic herring",
      "name": "Clu h",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Clupea harengus",
      "tissue": "Muscle",
      "discription": "The positive test for atlantic herring, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Atlantic herring",
      "name": "Clu h 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Clupea harengus",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Atlantic mackerel",
      "name": "Sco s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Scomber scombrus",
      "tissue": "Muscle",
      "discription": "The positive test for mackerel, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Atlantic mackerel",
      "name": "Sco s 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Scomber scombrus",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Black-Tiger shrimp",
      "name": "Pen m 1",
      "type": "M",
      "moleculeName": "Tropomyosin",
      "latinName": "Penaeus monodon",
      "tissue": "Muscle",
      "discription": "Group of arthropod muscle proteins; They are present in crustaceans, sea and soil mollusks, insects and mites; depending on the route of exposure, the positivity for one of these allergens is rarely associated with mild symptoms by ingestion (itching of the mouth), intestinal, or cutaneous generalized ones; frequently it causes severe anaphylactic reactions; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma. This allergen is resistant to cooking."
    },
    {
      "commonName": "Black-Tiger shrimp",
      "name": "Pen m 2",
      "type": "M",
      "moleculeName": "Arginine Kinase",
      "latinName": "Penaeus monodon",
      "tissue": "Muscle",
      "discription": "Group of proteins from arthropods; present in crustacean, but also in insects and mites; depending on the route of exposure, the positivity for one of these allergens is associated with mild symptoms by ingestion (itching of the oral cavity), or intestinal, or generalized cutaneous; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma."
    },
    {
      "commonName": "Black-Tiger shrimp",
      "name": "Pen m 3",
      "type": "M",
      "moleculeName": "Myosin",
      "latinName": "Penaeus monodon",
      "tissue": "Muscle",
      "discription": "Group of arthropod muscle proteins; They are present in crustaceans, sea and soil mollusks, insects and mites; depending on the route of exposure, the positivity for one of these allergens is rarely associated with mild symptoms by ingestion (itching of the mouth), intestinal, or cutaneous generalized ones; frequently it causes severe anaphylactic reactions; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma. This allergen is resistant to cooking."
    },
    {
      "commonName": "Black-Tiger shrimp",
      "name": "Pen m 4",
      "type": "M",
      "moleculeName": "SCBP",
      "latinName": "Penaeus monodon",
      "tissue": "Muscle",
      "discription": "Group of proteins found in crustacean; ingestion of these allergens is associated with mild symptoms (itching of the mouth), or intestinal, or generalized skin ones."
    },
    {
      "commonName": "Brown shrimp",
      "name": "Cra c 6",
      "type": "M",
      "moleculeName": "Troponin",
      "latinName": "Crangon crangon",
      "tissue": "Muscle",
      "discription": "Group of arthropod muscle proteins; They are present in crustaceans, sea and soil mollusks, insects and mites; depending on the route of exposure, the positivity for one of these allergens is rarely associated with mild symptoms by ingestion (itching of the mouth), intestinal, or cutaneous generalized ones; frequently it causes severe anaphylactic reactions; inhalation of this allergen can cause respiratory symptoms like rhinitis and asthma. This allergen is resistant to cooking."
    },
    {
      "commonName": "Carp",
      "name": "Cyp c 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Cyprinus carpio",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Common mussel",
      "name": "Myt e",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Mytilus edulis",
      "tissue": "Muscle",
      "discription": "The positive test for blu mussels, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Crab",
      "name": "Chi spp.",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Chionoecetes opilio",
      "tissue": "Muscle",
      "discription": "The positive test for snowcrab, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Lobster",
      "name": "Hom g",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Homarus gammarus",
      "tissue": "Muscle",
      "discription": "The positive test for the European lobster, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Northern prawn",
      "name": "Pan b",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Pandalus borealis",
      "tissue": "Muscle",
      "discription": "The positive test for prawn, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Oyster",
      "name": "Ost e",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ostrea edulis",
      "tissue": "Muscle",
      "discription": "The positive test for common oysters, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Salmon",
      "name": "Sal s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Salmo salar",
      "tissue": "Muscle",
      "discription": "The positive test for salmon, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Salmon",
      "name": "Sal s 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Salmo salar",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Scallop",
      "name": "Pec spp.",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Pecten maximus",
      "tissue": "Muscle",
      "discription": "The positive test for king scallop, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Shrimp mix",
      "name": "Lit s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Litopenaeus vannamei",
      "tissue": "Muscle",
      "discription": "Allergy to this extract can an include a wide range of symptoms from mild (e.g., hives and gastrointestinal distress) to severe (e.g., anaphylaxis). Exposure typically occurs through ingestion, inhalation, or skin contact, with ingestion being the most common route.*"
    },
    {
      "commonName": "Squid",
      "name": "Lol spp.",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Loligo vulgaris",
      "tissue": "Muscle",
      "discription": "The positive test for squid, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Swordfish",
      "name": "Xip g 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Xiphias gladius",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Thornback ray",
      "name": "Raj c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Raja clavata",
      "tissue": "Muscle",
      "discription": "The positive test for ray, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Thornback ray",
      "name": "Raj c Parvalbumin",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Raja clavata",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Tuna",
      "name": "Thu a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Thunnus albacares",
      "tissue": "Muscle",
      "discription": "The positive test for thuna, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Tuna",
      "name": "Thu a 1",
      "type": "M",
      "moleculeName": "Parvalbumin",
      "latinName": "Thunnus albacares",
      "tissue": "Muscle",
      "discription": "Specific allergen marker of allergy to fish, present in all fishes, but also in amphibians (frogs) and reptiles; It can cause symptoms both by ingestion, in the bowel, but also in the skin (urticaria and eczema), and can cause severe generalized reactions up to anaphylaxis. This allergen is resistant to cooking."
    },
    {
      "commonName": "Venus clam",
      "name": "Rud spp.",
      "type": "E",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "The positive test for clam, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Anise",
      "name": "Pim a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Pimpinella anisum",
      "tissue": "Seed",
      "discription": "The positive test for aniseed, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Caraway",
      "name": "Car c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Carum carvi",
      "tissue": "Seed",
      "discription": "The positive test for caraway, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Mustard",
      "name": "Sin a",
      "type": "E",
      "moleculeName": "N/A",
      "latinName": "N/A",
      "tissue": "N/A",
      "discription": "The positive test for mustard, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Mustard",
      "name": "Sin a 1",
      "type": "M",
      "moleculeName": "2S Albumin",
      "latinName": "Sinapis alba",
      "tissue": "Seed",
      "discription": "Group of seed storage proteins; the positivity for one of these allergens may be associated with that of other molecules of the same group, but there is much variability of the IgE response between different subjects; Ingestion can cause mild symptoms (itching of the mouth), intestinal, and generalized cutaneous ones;It is a common cause of severe anaphylactic reactions."
    },
    {
      "commonName": "Oregano",
      "name": "Ori v",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Origanum vulgare",
      "tissue": "Leaf",
      "discription": "Its clinical significance primarily relates to IgE-mediated allergic reactions that can occur through ingestion, inhalation, or skin contact. The most common allergic symptoms include hives, respiratory issues, gastrointestinal distress, and, in rare cases, anaphylaxis. Oral Allergy Syndrome (OAS) may also occur in individuals with tree pollen allergies. Cross-reactivity with other herbs from the Lamiaceae family is also a concern.*"
    },
    {
      "commonName": "Paprika",
      "name": "Cap a",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Capsicum annuum, Solanaceae",
      "tissue": "Fruit",
      "discription": "Exposure may cause mild symptoms like hives or rhinitis to more severe reactions like anaphylaxis. Ingestion and inhalation are the most common routes of exposure, while skin contact can also trigger allergic reactions, particularly in sensitive individuals. Individuals with an allergy to paprika should avoid not only paprika but also other nightshade plants (e.g., tomatoes, eggplants, peppers) due to possible cross-reactivity.*"
    },
    {
      "commonName": "Parsley",
      "name": "Pet c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Petroselinum crispum",
      "tissue": "Leaf",
      "discription": "Parsley allergy is relatively uncommon, documented cases highlight its potential to elicit a range of allergic reactions. Reported clinical manifestations include Oral Allergy Syndrome (OAS), urticaria and angioderma, contact dermatitis, and anaphylaxis.  The primary route of exposure is through ingestion of parsley, especially in its raw form. Contact with the skin and inhalation of airborne particles may contribute to sensitization.*"
    },
    {
      "commonName": "Carrot",
      "name": "Dau c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Daucus carota",
      "tissue": "Root",
      "discription": "The positive test for carrot, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Carrot",
      "name": "Dau c 1",
      "type": "M",
      "moleculeName": "Fagales-related, Group 1; Bet v 1-like",
      "latinName": "Daucus carota",
      "tissue": "Root",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Celery",
      "name": "Api g 1",
      "type": "M",
      "moleculeName": "Fagales-related, Group 1; Bet v 1-like",
      "latinName": "Apium graveolens",
      "tissue": "Leaf, Root",
      "discription": "Specific allergen markers present in the pollen of the Fagales (birch, hazel, alder, oak) and in many plant foods (apple, peach, celery, carrot, hazelnut, soy, kiwi); the pollen allergens can cause symptoms by inhalation as rhinitis, conjunctivitis, asthma in pre-spring and springtime; food allergens can cause local symptoms (itching of the oral cavity), but, rarely, even generalized severe ones, by ingestion of one or more foods with high allergen concentrations."
    },
    {
      "commonName": "Celery",
      "name": "Api g 2",
      "type": "M",
      "moleculeName": "LTP",
      "latinName": "Apium graveolens",
      "tissue": "Stalk",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Celery",
      "name": "Api g 6",
      "type": "M",
      "moleculeName": "LTP, 7k-LTP",
      "latinName": "Apium graveolens",
      "tissue": "Root",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Garlic",
      "name": "All s",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Allium sativum",
      "tissue": "Bulb",
      "discription": "The positive test for garlic, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Onion",
      "name": "All c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Allium cepa",
      "tissue": "Seed, Bulb",
      "discription": "The positive test for onion, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Potato",
      "name": "Sol t",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Solanaceae Solanum tuberosum",
      "tissue": "Tuber",
      "discription": "The positive test for potato, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Tomato",
      "name": "Sola l",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Solanaceae Solanum lycopersicum",
      "tissue": "Fruit",
      "discription": "The positive test for tomato, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Tomato",
      "name": "Sola l 6",
      "type": "M",
      "moleculeName": "LTP; 7k-LTP",
      "latinName": "Solanaceae Solanum lycopersicum",
      "tissue": "Fruit, Seed",
      "discription": "Group of allergens present in different tissues of plants. Although they have the same biological function, the lipid-transfer proteins (LTP) have different molecular weights (7k, 9k, 11k), with different specific IgE binding from allergy subjects. Those present in foods (7k and 9k) can cause generalized symptoms even severe by ingestion of one or more foods, while the 11k-LTP is described only in the pollen of Parietaria causing mild symptoms by inhalation (rhinitis and conjunctivitis), frequently asthma."
    },
    {
      "commonName": "Baker's yeast",
      "name": "Sac c",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Saccharomyces cerevisiae",
      "tissue": "Whole Body",
      "discription": "The positive test for yeast, evaluated using a protein extract (mixture), it must be interpreted in relation to its allergenic molecules and to the similar ones contained in related extracts. A positive result for this extract can also be due to a known allergenic protein not yet available in the tests or not identified yet."
    },
    {
      "commonName": "Hom s lactoferrin",
      "name": "Hom s LF",
      "type": "M",
      "moleculeName": "Lactoferrin; CCD-bearing Protein (XF)",
      "latinName": "Homo sapiens",
      "tissue": "Milk",
      "discription": "Although human lactoferrin is typically non-allergenic, studies have indicated its potential to induce allergic reactions. These findings suggest that, in sensitized individuals, exposure to lactoferrin could potentially trigger symptoms such as nasal congestion and rhinorrhea, coughing and wheezing, shortness of breath, urticaria, and gastrointestinal discomfort\u200b. Potential exposure routes to human lactoferrin include inhalation, ingestion, and topical application.*"
    },
    {
      "commonName": "Latex",
      "name": "Hev b 1",
      "type": "M",
      "moleculeName": "Elongation Factor",
      "latinName": "Hevea brasiliensis",
      "tissue": "Latex",
      "discription": "Specific allergen marker of latex allergy; It can cause local symptoms by contact (urticaria) or generalized cutaneous and respiratory symptoms."
    },
    {
      "commonName": "Latex",
      "name": "Hev b 3",
      "type": "M",
      "moleculeName": "Small Rubber Particle Protein",
      "latinName": "Hevea brasiliensis",
      "tissue": "Latex",
      "discription": "Specific allergen marker of latex allergy; It can cause local symptoms by contact (urticaria) or generalized cutaneous and respiratory symptoms."
    },
    {
      "commonName": "Latex",
      "name": "Hev b 5",
      "type": "M",
      "moleculeName": "Hev b 5-like",
      "latinName": "Hevea brasiliensis",
      "tissue": "Latex",
      "discription": "Specific allergen marker of latex allergy; It can cause local symptoms by contact (urticaria) or generalized cutaneous and respiratory symptoms; proteins belonging to this group have been described in foods."
    },
    {
      "commonName": "Latex",
      "name": "Hev b 6.02",
      "type": "M",
      "moleculeName": "Hevein-like",
      "latinName": "Hevea brasiliensis",
      "tissue": "Latex",
      "discription": "Specific allergen marker of allergy to latex, but molecules of the same group are present in many plant foods;It can cause local symptoms by contact (urticaria) or generalized cutaneous and respiratory symptoms; by ingestion of proteins in this group there can be mild or severe skin reactions, gastrointestinal symptoms, and generalized symptoms up to severe anaphylaxis."
    },
    {
      "commonName": "Latex",
      "name": "Hev b 8",
      "type": "M",
      "moleculeName": "Profilin",
      "latinName": "Hevea brasiliensis",
      "tissue": "Latex",
      "discription": "Group of allergens commonly present in many plant species, both in pollen and in edible parts; It can cause symptoms by inhalation generally mild throughout the period of presence of any pollen; It can cause local symptoms by ingestion (itching of the mouth)."
    },
    {
      "commonName": "Latex",
      "name": "Hev b 11",
      "type": "M",
      "moleculeName": "Hevein-like Chitinase",
      "latinName": "Hevea brasiliensis",
      "tissue": "Latex",
      "discription": "Specific allergen marker of allergy to latex, but molecules of the same group are present in many plant foods; It can cause local symptoms by contact (urticaria) or generalized cutaneous and respiratory symptoms; by ingestion of proteins in this group there can be mild or severe skin reactions, gastrointestinal symptoms, and generalized symptoms up to severe anaphylaxis."
    },
    {
      "commonName": "Pigeon tick",
      "name": "Arg r 1",
      "type": "M",
      "moleculeName": "Lipocalin",
      "latinName": "Argas reflexus",
      "tissue": "Saliva",
      "discription": "Group of allergens derived from animal present in the skin, but also in other tissues (secretions, saliva, milk); the positivity for one of these allergens may be associated with that of the other molecules of the same group, but there is much variability of the IgE response between different subjects; It causes symptoms by inhalation as rhinitis and asthma, often severe"
    },
    {
      "commonName": "Weeping fig",
      "name": "Fic b",
      "type": "E",
      "moleculeName": "///",
      "latinName": "Ficus benjamina",
      "tissue": "Latex",
      "discription": "Allergic responses to Fic b primarily affect the respiratory system and skin. Documented symptoms include allergic rhinoconjunctivitis, asthma, urticaria, eyelid edema. There is documented cross-reactivity between Fic b, natural rubber latex, and fig fruit (Ficus carica).*"
    }
  ];



  const Header = () => {

    return (<>
      <div className="info">
        <div className="info-box">
          <div style={{ display: 'flex', gap: '10px' }}> <p style={{ fontWeight: "700" }}>Patient:</p><p style={{ fontWeight: '500', fontFamily: 'overpass' }}> {kit.patientName}</p></div>
          <div style={{ display: 'flex', gap: '10px' }}> <p style={{ fontWeight: "700" }}>Birth date:</p><p style={{ fontWeight: '500', fontFamily: 'overpass' }}> {new Date(kit.DOB).toLocaleDateString('en-GB')}</p></div>
          <div style={{ display: 'flex', gap: '10px' }}> <p style={{ fontWeight: "700" }}>QR code:</p><p style={{ fontWeight: '500', fontFamily: 'overpass' }}> {kit.Qrcode}</p></div>
          <div style={{ display: 'flex', gap: '10px' }}> <p style={{ fontWeight: "700" }}>Patient code:</p><p style={{ fontWeight: '500', fontFamily: 'overpass' }}> {kit.kitid}</p></div>
        </div>
        <div className="info-box" style={{ textAlign: 'right' }}>
          <div style={{ display: 'flex', gap: '10px', textAlign: 'end' }}>  <p style={{ fontWeight: '700' }}>Doctor Info:</p> <p style={{ fontWeight: '500', fontFamily: 'overpass' }}>{kit.doctorInfo}</p></div>
          <div style={{ display: 'flex', gap: '10px', textAlign: 'end' }}>  <p style={{ fontWeight: '700' }}>Sample date:</p> <p style={{ fontWeight: '500', fontFamily: 'overpass' }}>{new Date(kit.SampleDate).toLocaleDateString('en-GB')}</p></div>
          <div style={{ display: 'flex', gap: '10px', textAlign: 'end' }}>  <p style={{ fontWeight: '700' }}>Test date:</p> <p style={{ fontWeight: '500', fontFamily: 'overpass' }}>{kit.resultDate}</p></div>
        </div>
      </div>

    </>)
  }


  const Footer = (page) => {

    return (<>
      <div style={{ color: "#26396E", fontFamily: 'overpass' }}>
        <div style={{ borderBottom: '1px solid #00B388', marginBottom: '10px' }}>
          *M: molecular allergen; E: allergen extract
        </div>
        {/* <h5 align="center" style={{ fontWeight: 'bolder' }}>Specific IgE values: 0,3 kUA/L Negative or doubtful; 0,3-1 KUA/L Low; 1-5 kUA/L Moderate; 5-15 KUA/L High; 15 KUA/L Very high </h5> */}
        {/* <div style={{ textAlign: 'center' }}>
          <p>Performed in service by Global Medical Technologies Manila, Inc. </p>
          
          <p>Aurora Blvd., Quezon City, Philippines </p>
          
          <p><strong>Mobile:</strong> <a href='tel:+639178289676' style={{textDecoration:"none",color:"#1B365D"}}> +63 917 828 9676</a> {""}
          <strong>Email:</strong><a href='mailto:info@gmtmanila.com' style={{textDecoration:"none",color:"#1B365D"}}>  info@gmtmanila.com </a></p>
        </div> */}
<div className='downfooter'>
  <div className='subdownfooter'>
    <h5>{"<"}0.3KUA/L</h5>
    <div className='subdownfootercolorbox' ></div>
    <h5>Negative or Uncertain</h5>
  </div>

  <div className='subdownfooter'>
    <h5>0.3 - 1KUA/L</h5>
    <div className='subdownfootercolorbox' ></div>
    <h5>Low IgE level</h5>
  </div>

  <div className='subdownfooter'>
    <h5>1 - 5KUA/L</h5>
    <div style={{backgroundColor:"yellow"}} className='subdownfootercolorbox' ></div>
    <h5>Moderate IgE level</h5>
  </div>

  <div className='subdownfooter'>
    <h5>5 - 15KUA/L</h5>
    <div style={{backgroundColor:"orange"}} className='subdownfootercolorbox' ></div>
    <h5>High IgE level</h5>
  </div>

  <div className='subdownfooter'>
    <h5>{">"}15KUA/L</h5>
    <div style={{backgroundColor:"red"}} className='subdownfootercolorbox' ></div>
    <h5>Very High IgE level</h5>
  </div>
</div>

        
        <div style={{ textAlign: 'end' }}>
          Page {page.page}
        </div>
      </div>

    </>)
  }


  const Table = (pranms) => {

    return (<>
      <table>
        <thead>
          <tr>
            {/* <th>Latin name</th> */}
            <th>Common name</th>
            {/* <th>Tissue</th> */}
            <th>Type</th>
            {/* <th>Molecule name</th> */}
            <th>Allergen</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

          {clinicalRelevanceData.slice(pranms.starting, pranms.ending).map((item, index) => {

            let backgroundColor = "#fff"
            let color = "#000"

            if (kit.result && kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value <= 1) {
              backgroundColor = "#fff"
              color = "#000"

            } else if (kit.result && kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value > 1 && kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value < 6) {
              backgroundColor = "yellow"
              color = "#000"

            }
            else if (kit.result && kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value > 5 && kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value < 16) {
              backgroundColor = "orange"
              color = "#000"

            }
            else if (kit.result && kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value >= 16) {
              backgroundColor = "red"
              color = "#fff"

            }

            return (<>
              <tr>
              <td>
                {item.commonName}
              </td>
              <td>
                {item.type}
              </td>
              <td>{item.name}</td>
              <td style={{ backgroundColor: backgroundColor, color: color }}>
                {kit.result && item.name
                ? (kit.result.find((data) => data.name.toLowerCase() === item.name.toLowerCase())?.value ?? 0).toFixed(2)
                : "loading.."}
              </td>
              </tr>
            </>)
          })}
        </tbody>
      </table>

    </>)
  }



  const Discription = (pranms) => {

    return (<>
      <div>
        {totaldistoshow.slice(pranms.starting, pranms.ending).map((item, index) => (
          <>
            {/* <p><strong></strong></p> */}
            <p style={{ margin: '0', marginTop: "20px" }}>
              <strong>{clinicalRelevanceData.find((value) => item.name === value.name)?.name || "Nan"}:</strong> </p>
            <p className='discriptionnnn' style={{ fontFamily: 'overpass',lineHeight:'1.2' }}>  {clinicalRelevanceData.find((value) => item.name === value.name)?.discription || <>{"Please contact GMT for more information."}</>}
            </p>

          </>
        ))}
      </div>

    </>)
  }

  const sum = Math.round(kit.result?.reduce((acc, item) => acc + Number(item.value), 0))

  const Andicator = (value) => {

    let person = sum

    if (sum > 100) {
      person = 95
    }

    return (<>
      <div class="range">
        <div class="indicator" style={{ left: `${person}%` }}></div>
      </div>
    </>)
  }

  const download = async () => {
    await setdoadinggg(true)
    // Hide the button by adding the class
    const button = document.getElementById('downloadButton');
    if (button) button.classList.add('hide-for-pdf');

    const pdf = new jsPDF();
    const pages = document.querySelectorAll('.page');

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], { scale: 3 });
      const imgData = canvas.toDataURL('image/png');

      if (i > 0) {
        pdf.addPage();
      }

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = 210;
      const imgHeight = 297;

      pdf.addImage(imgData, 'PNG', (pageWidth - imgWidth) / 2, (pageHeight - imgHeight) / 2, imgWidth, imgHeight, undefined, "FAST");
      // pdf.addImage(imgData, "JPEG", 5, 5, imgWidth, imgHeight, undefined, "FAST");
    }

    // Save the PDF
    pdf.save(`AllergyMap-report-${kit.kitid}.pdf`);

    // Show the button again by removing the class
    if (button) button.classList.remove('hide-for-pdf');
    await setdoadinggg(false)
  }
  return (
    <div className="App" style={{ position: 'relative' }}>
      {/* Page No 1 */}

      {doadinggg ? (<>  <div style={{ position: "absolute", top: '200px' }}>Downloading...</div>
      </>) : (<> <button className='button' style={{ position: "absolute", top: '200px' }} onClick={() => download()}>Download as PDF</button>
      </>)}
      {Array.from({
        length: Math.ceil((clinicalRelevanceData?.length - 17) / 22) + 1 // +1 for the first page
      }).map((_, i) => {
        let start, end;

        if (i === 0) {
          start = 0;
          end = 17;
        } else {
          start = 17 + (i - 1) * 22;
          end = start + 22;
        }

        return (
          <div className="page" key={i}>
            <div className="page-box">

              {i === 0 && <>
                <div className="logo">
                  <div className="logo-box" ><img src='/allergynew.png' width={"100%"} /></div>
                  <div className="logo-box"><img src='/alex.png' width={"100%"} /></div>
                  <div className="logo-box"><img src='/GMT.png' width={"100%"} /></div>
                </div>
              </>}

              <Header />
              <Table starting={start} ending={end} />
              <Footer page={i + 1} />
            </div>
          </div>
        );
      })}




      {/* color bar */}
      <div className="page">
        <div className="page-box">

          <Header />
          <div className="color-bar">
            <div class="card">
              <div class="reference" style={{ fontFamily: "overpass" }}>
                Reference range total-IgE<br />
                Adults: &lt; 100 kU/L
              </div>
              <div>

                <h2 style={{ color: "#1B365D", fontFamily: "Josefin Sans" }}>
                  Total IgE result:{" "}
                  <strong>
                    {sum} kU/L
                  </strong>
                </h2>


              </div>
              <Andicator />
              <div class="labels" style={{ fontFamily: "overpass" }}>
                <span>0 kU/L</span>
                <span>+100 kU/L</span>
              </div>
            </div>


          </div>

          <Footer page={(Math.ceil((kit.result?.length - 17) / 22) + 1) + 1} />
        </div>
      </div>





      {/* discription */}
      {Array.from({ length: Math.ceil(totaldistoshow.length / 9) }).map((_, i) => {
        const start = i * 9;
        const end = start + 9;

        return (
          <div className="page" key={i}>
            <div className="page-box">
              <Header />


              {i === 0 && <>

                <div>
                  <p style={{ fontFamily: "Josefin Sans", margin: 0 }}>
                    <strong >Clinical Relevance</strong>
                    <br />
                  </p><p style={{ fontFamily: "overpass", margin: '0',lineHeight:'1.2' }}>
                    A specific IgE sensitization has been detected to some allergenic molecule or extract preparations, as indicated above.
                  </p>
                </div>

              </>}
              <Discription starting={start} ending={end} />



              {i === Math.ceil(totaldistoshow.length / 9) - 1 && <>


                {totaldistoshow.length === 0 ? (<>
                  <p style={{ fontFamily: "overpass", margin: '0',lineHeight:'1.2' }}>
                    No specific IgE sensitization has been detected to any of the allergenic preparations included in this test.
                    However, we recommend a specialist to verify your symptoms as the negative results of this test do not rule out
                    the presence of allergy-like symptoms.
                    It is also possible that symptoms are caused by the exposure to a rare allergen or by a non-IgE-mediated
                    mechanism. </p>

                </>) : (<>
                  <p style={{ fontFamily: "overpass", margin: '0',lineHeight:'1.2' }}>
                    The information and comments are reported as an aid in the interpretation of the test and do not constitute and
                    replace in any way a final clinical diagnosis.
                    For a more complete diagnostic evaluation and the following therapy, you should contact your attending
                    physician.     </p>

                </>)}


              </>}

              <Footer page={((Math.ceil((kit.result?.length - 17) / 22) + 1) + 1) + i + 1} />
            </div>
          </div>
        );
      })}


    </div>
  );
}

export default App;
